import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad3Actividad4.mp3";

const Actividad7 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[4];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[5].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[5].path}`,
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[3].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[3].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
        <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12 p-0">
          <ul className="">
            <li>
              En cada uno de los siguientes recuadros, encontrarás cuatro
              palabras.
            </li>
            <li>
              Para cada recuadro, crea dos oraciones donde uses al menos dos
              palabras del conjunto (no las repitas).
            </li>
            
          </ul>
          <Card>
            <div className="d-flex justify-content-between">
              <div className="m-1">ciudad</div>
              <div className="m-1">servicios</div>
              <div className="m-1">población</div>
              <div className="m-1">recursos</div>
            </div>
          </Card>
          Oración 1:
          <textarea className="form-control mb-2" rows={2} />
          Oración 2:
          <textarea className="form-control" rows={2} />
          <Card>
            <div className="d-flex justify-content-between">
              <div className="m-1">construcciones</div>
              <div className="m-1">material</div>
              <div className="m-1">ciudad</div>
              <div className="m-1">planificación</div>
            </div>
          </Card>
          Oración 1:
          <textarea className="form-control mb-2" rows={2} />
          Oración 2:
          <textarea className="form-control" rows={2} />{" "}
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: En cada uno de los siguientes recuadros,
            encontrarás cuatro palabras. Pida a un o una estudiante que lea en
            voz alta las palabras propuestas en los recuadros. Pregunte si tienen claro el significado de todas las palabras. En
            caso contrario, puede utilizar el diccionario o brindarles los
            significados siguientes:
            <ul>
              <li>
                <i>
                  “Ciudad: Viviendas, edificios y calles, regidos por una
                  municipalidad. Lugar urbano en el que se concentra una gran
                  cantidad de población.
                </i>
              </li>
              <li>
                <i>
                  Servicios: Actividades llevadas a cabo por el Estado, la
                  Municipalidad, una empresa o una organización particular, que
                  brinda la satisfacción de las necesidades de un grupo de
                  personas.
                </i>
              </li>
              <li>
                <i>
                  Población: Conjunto de personas que habitan en un determinado
                  lugar.
                </i>
              </li>
              <li>
                <i>
                  Recursos: Conjunto de elementos para cubrir una necesidad.
                </i>
              </li>
              <li>
                <i>Construcciones: Obra construida o edificada.</i>
              </li>
              <li>
                <i>
                  Material: Elemento ingrediente de algún compuesto. Conjunto de
                  objetos para desarrollar un servicio o profesión.
                </i>
              </li>
              <li>
                <i>
                  Planificación: Plan organizado que busca obtener un
                  determinado objetivo”. (Tomado de: Diccionario de la Real
                  Academia de la Lengua Española. Versión en línea: www.rae.es).
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la siguiente indicación: Para cada recuadro, crea dos oraciones
            donde uses al menos dos palabras del conjunto (no las repitas). Dé
            un tiempo para que escriban. Lea la siguiente
            indicación: Luego, comparte tu trabajo con el resto de tus
            compañeros y compañeras. Es importante que revise el sentido de las
            oraciones. Cuando una oración no sea coherente, explique al
            estudiante por qué no es una oración clara. Ayúdelo a construir una
            nueva oración.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
